import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormTaxDelete() {
  const { setModal, setInvoice, getInvoice, deleteTaxes } =
    useContext(ExportContext)!.controllers.tax;

  const [loading, setLoading] = useState(false);

  const selectedTax = getInvoice('selected.tax');
  const selectedTaxes = getInvoice('selecteds.taxes');
  const taxIds = selectedTax !== -1 ? [selectedTax] : selectedTaxes;
  const length = taxIds.length;

  const close = () => {
    setModal('single.deleteTaxes', false);
    setInvoice('selected.tax', -1);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteTaxes(taxIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir a taxa?'
            : `Tem certeza que deseja excluir ${length} taxas?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
